/**
 * @deprecated Use `Brand` from `common/Brand`. This name meant both the product axis and a shef's
 *   page; PR-AC removes these aliases.
 */
export { Brand as Storefront, brandDisplayName as storefrontDisplayName, parseBrand as parseStorefront } from './Brand';
